import { render, staticRenderFns } from "./DashboardInstitutionAdmin.vue?vue&type=template&id=3bf334f4&scoped=true"
import script from "./DashboardInstitutionAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardInstitutionAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardInstitutionAdmin.vue?vue&type=style&index=0&id=3bf334f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf334f4",
  null
  
)

export default component.exports